import SignUp from "../LoginSignUp/SignUp";

export default function Registration(){
    return <SignUp/>
}